// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import pt from './metaData/pt'
export default {
  state: pt,
  actions
}
